module.exports = __webpack_public_path__ + "static/img/主视觉KV设计-主视觉KV延展.0805835.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10001/主视觉KV设计-主视觉KV延展.png
// module id = Z3Zw
// module chunks = 1